export const API_ADMIN_GET_ALL_LAB_PARAM_GROUP = 'API_ADMIN_GET_ALL_LAB_PARAM_GROUP'
export const API_ADMIN_GET_ALL_LAB_PARAM_GROUP_SUCCESS = 'API_ADMIN_GET_ALL_LAB_PARAM_GROUP_SUCCESS'
export const API_ADMIN_GET_ALL_LAB_PARAM_GROUP_FAIL = 'API_ADMIN_GET_ALL_LAB_PARAM_GROUP_FAIL'

export const API_ADMIN_GET_LAB_PARAM_GROUP = 'API_ADMIN_GET_LAB_PARAM_GROUP'
export const API_ADMIN_GET_LAB_PARAM_GROUP_SUCCESS = 'API_ADMIN_GET_LAB_PARAM_GROUP_SUCCESS'
export const API_ADMIN_GET_LAB_PARAM_GROUP_FAIL = 'API_ADMIN_GET_LAB_PARAM_GROUP_FAIL'

export const API_ADMIN_POST_LAB_PARAM_GROUP = 'API_ADMIN_POST_LAB_PARAM_GROUP';
export const API_ADMIN_POST_LAB_PARAM_GROUP_SUCCESS = 'API_ADMIN_POST_LAB_PARAM_GROUP_SUCCESS';
export const API_ADMIN_POST_LAB_PARAM_GROUP_FAIL = 'API_ADMIN_POST_LAB_PARAM_GROUP_FAIL';

export const API_ADMIN_PATCH_LAB_PARAM_GROUP = 'API_ADMIN_PATCH_LAB_PARAM_GROUP';
export const API_ADMIN_PATCH_LAB_PARAM_GROUP_SUCCESS = 'API_ADMIN_PATCH_LAB_PARAM_GROUP_SUCCESS';
export const API_ADMIN_PATCH_LAB_PARAM_GROUP_FAIL = 'API_ADMIN_PATCH_LAB_PARAM_GROUP_FAIL';

export const API_ADMIN_DELETE_LAB_PARAM_GROUP = 'API_ADMIN_DELETE_LAB_PARAM_GROUP';
export const API_ADMIN_DELETE_LAB_PARAM_GROUP_SUCCESS = 'API_ADMIN_DELETE_LAB_PARAM_GROUP_SUCCESS';
export const API_ADMIN_DELETE_LAB_PARAM_GROUP_FAIL = 'API_ADMIN_DELETE_LAB_PARAM_GROUP_FAIL';

export const ADMIN_INIT_NEW_LAB_PARAM_GROUP = 'ADMIN_INIT_NEW_LAB_PARAM_GROUP'

export const ADMIN_RESET_FOCUS_LAB_PARAM_GROUP = 'ADMIN_RESET_FOCUS_LAB_PARAM_GROUP'
